import { Component, Injector } from '@angular/core';
import { RelatedTabBaseComponent } from '../related-tab-base.component';
import { EMPTY, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs';
import { EmailThreadDocToDocViewerContextDocMapper } from '@models/mappers/doc-viewer/email-thread-doc-to-doc-viewer-context-doc.mapper';
import { Router } from '@angular/router';
import { ComparisonUtility } from '@utilities/comparison.utility';
import { EmailThreadGroupingsService } from '@services/email-thread-groupings.service';
import { DocumentConextListState } from '@store/doc-viewer/document-list/document-list.state';

@Component({
    selector: 'lex-email-threading-context-panel',
    templateUrl: './email-threading-context-panel.component.html',
    styleUrls: ['./email-threading-context-panel.component.scss'],
    standalone: false
})
export class EmailThreadingContextPanelComponent extends RelatedTabBaseComponent {
	public emailThreadingListContext: DocumentConextListState = {
		docList: [],
		isExpandedResults: false
	};
	private threadGroupId: string;
	private mapper: EmailThreadDocToDocViewerContextDocMapper = new EmailThreadDocToDocViewerContextDocMapper();

	constructor(
		private injector: Injector,
		private router: Router,
		private emailThreadGroupingsService: EmailThreadGroupingsService
	) {
		super(injector);
		this.docViewerStore.simpleState$.pipe(
			distinctUntilChanged((a, b) => ComparisonUtility.isEqual(a.emailThreadGroupingId, b.emailThreadGroupingId)),
			tap((x) => {
				if (x.emailThreadGroupingId) {
					this.threadGroupId = x.emailThreadGroupingId;
				}
			}),
			switchMap((x) => {
				if (x.emailThreadGroupingId) {
					return emailThreadGroupingsService.getEmailThreadDocs(x.emailThreadGroupingId);
				}
				return EMPTY;
			}),
			takeUntil(this.destroy$)
		).subscribe((x) => {
			if (x) {
				this.emailThreadingListContext = {
					...this.emailThreadingListContext,
					docList: this.mapper.mapCollection(x.sort((x, y) => x.fieldPath.localeCompare(y.fieldPath)))
				};
			}
		});
	}

	public navigateToThreading(): void {
		this.router.navigate([`analytics/email-thread/${this.threadGroupId}`]);
	}
}
